import {FormattedMessage} from 'react-intl';
import {Link, useParams, useNavigate} from 'react-router-dom';
import axios from "axios";
import {connect} from "react-redux";
import getAxiosConfig from "../../utils/axiosConfig";
import React, {useState, Fragment} from "react";
import {showToastForBackend, showToastForFrontend} from "../../actions/toastActions";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const AddLogicInput = (props) => {

    const [logicName, setLogicName] = useState("");


    const logicSubmit = (e) => {
        e.preventDefault();
        axios.post(props.properties.logicUrl + "/new",
            {
                "logicName": logicName,
                "logicType": "MASTER",
                "userEmail": localStorage.getItem("user")
            },
            getAxiosConfig()).then((result) => {
            if (result) {
                setLogicName("");
                props.history(`/logics/${result.data.logic.id}`);
            }
        }).catch((err) => {
            if (err.response) {
                props.showToastForBackend(err.response.data);
            }
        });
    }

    const handleChangeInput = (e) => {
        setLogicName(e.target.value)
    }
    const validateLogicName = (e) => {
        if (!/[0-9a-zA-Z_]/.test(e.key)) {
            e.preventDefault();
            const tip = tippy('#logicName', {
                duration: [0, 5000],
                hideOnClick: true,
                placement: 'top',
                trigger: 'manual',
                content: "Only Latin letters, numbers and underscores are allowed",
                theme: 'warning'
            });
            tip[0].show();
        }
    }

    return (
        <Fragment>
            <div className="backdrop" onClick={props.onClickClose}/>
            <div className="logic-input-form">
                <span className="close-span" onClick={props.onClickClose}>
                &times;
                </span>
                <div className="title">
                    <span><FormattedMessage id="Add new logic"/></span>
                </div>
                <div className="input-area">
                    <form onSubmit={logicSubmit}>
                        <FormattedMessage id="Type logic name here">
                            {placeholder =>
                                <input id="logicName"
                                       placeholder={placeholder}
                                       name="logicName"
                                       value={logicName}
                                       onChange={handleChangeInput}
                                       onKeyDown={(e) => validateLogicName(e)}
                                />
                            }
                        </FormattedMessage>
                        <button><FormattedMessage id="Add New" onClick={props.onClickClose}/></button>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
    }
}

//eslint-disable-next-line react/display-name
const withRouter = AddLogicInput => props => {
    const params = useParams();
    const history = useNavigate();
    return (
        <AddLogicInput {...props} {...{params, history}}/>
    );
};

export default withRouter(connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(AddLogicInput));